import {AccessLog, Tile} from "../model";
import {CrudDataList, CrudRepository} from ".";
import Keycloak from "keycloak-js";
import axios from "redaxios";
import {isEmpty} from "../utils/control/isEmpty";

export class AccessLogRepository extends CrudRepository<AccessLog> {
    constructor(keycloak: Keycloak | null = null) {
        super('access_logs', "PATCH", keycloak)
        this.contentTypes["UPDATE"] = "application/merge-patch+json"
    }

    protected jsonToEntity(json: any): AccessLog | null {
        if (!json) return null;
        return {
            id: json.id,
            createdAt: json.createdAt,
            updatedAt: json.updatedAt,
            deletedAt: json.deletedAt,
            date: json.date,
            name: json.name,
            tileId: json.tileId,
            url: json.url,
            authGroups: json.authGroups,
            userAgent: json.userAgent,
            username: json.username,
            tileName: json.tileName
        }
    }

    protected async entityToJson(entity: AccessLog): Promise<any> {
        return super.entityToJson(entity);
    }
}